import storeApis from "../../api/storeApi";
import "react-toastify/dist/ReactToastify.min.css";
import * as types from "../../constants/SettingActionTypes";
import _ from "lodash";
import { toast } from "react-toastify";
import Toast from "../../components/assetLibComponents/shared/Toast";

// const LEAD_DETAILS_URL = "/framework/api/appLeadDetails";

export const setSettingUnauthorized = () => {
  return (dispatch) => {
    dispatch({ type: "UNAUTHORIZED_SETTING", payload: null });
  };
};

// Adding token

export const addUpdateToken = (authToken, key) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "chatbot/add_settings",
        {
          openai_key: key,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
          dispatch(getToken(authToken));
          setTimeout(() => {
            window.location.reload();
          }, 3000);
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
      // Toast(err.response, "E");
    }
  };
};

//Get token
export const getToken = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("chatbot/fetch_settings", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.FETCH_TOKEN,
            payload: response.data,
          });
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

// Add User
export const addUser = (authToken, newContact, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post("users/create_user", newContact, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          if (response.data.response) {
            Toast(response.data.response, "E");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          onSuccess();
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(fetchUserList(authToken));
        } else {
          Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
//User Listing
export const fetchUserList = (authToken, searchKeyword) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "users/user_list",
        {
          search: searchKeyword,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          // } else {
          //     Toast(response.data.message, "E");
          // }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          // Toast(response.data.message, "S");
          await dispatch({
            type: types.FETCH_USER_LIST,
            payload: null,
          });
          dispatch({
            type: types.FETCH_USER_LIST,
            payload: response.data,
          });
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const deleteUser = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "users/user_delete",
        {
          users_id: id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          await dispatch(fetchUserList(authToken));
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
export const fetchUserDetails = (authToken, id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "users/get_user",
        {
          users_id: id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          // if (response.data.message == "Invalid Credentials" || response.data.message == "Unauthenticated" || response.data.message == "Unauthorized") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          // } else {
          //     Toast(response.data.message, "E");
          // }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          // Toast(response.data.message, "S");
          dispatch({
            type: types.FETCH_USER_DETAILS,
            payload: response.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
//Edit user details
export const editUser = (authToken, newContact, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post("users/user_edit", newContact, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          if (response.data.response) {
            Toast(response.data.response, "E");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          onSuccess();
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch(fetchUserList(authToken));
        } else {
          Toast(response.data.message, "E");
        }
        dispatch({ type: "TOGGLE_LOADING", payload: false });
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

//User Listing
export const fetchTimezoneList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("timezone/list", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_TIMEZONE_LIST,
            payload: response?.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const saveTimezone = (authToken, time) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "timezone/save",
        {
          timezone: time,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
          await dispatch(fetchTimezoneList(authToken));
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const fetchBillingUrl = (authToken, key) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "stripe/session_checkout",
        { lookup_key: key },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          window.location.assign(response?.data?.session_url);
          await dispatch({ type: types.FETCH_BILLING_URL, payload: null });
          dispatch({
            type: types.FETCH_BILLING_URL,
            payload: response?.data?.session_url,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const fetchStripeLookupKey = (authToken,currenc) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "stripe/product_details",
        { currency: currenc },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: types.FETCH_LOOKUP_KEY, payload: response?.data });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const fetchBillingSubscriptions = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "stripe/session_history",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          window.location.assign(response?.data?.session_url);
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({
            type: types.FETCH_MANAGE_BILLING,
            payload: response?.data?.session_url,
          });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const fetchCurrentPlan = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("stripe/get_current_plan", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: types.FETCH_CURRENT_PLAN, payload: response?.data });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

//User Listing
export const fetchNotificationCheckList = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("notification/create", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.NOTIFICATION_CHECK_LIST,
            payload: response?.data?.data,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const saveNotificationPriority = (authToken, payload) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "notification/create",
        { data: payload },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
          dispatch(fetchNotificationCheckList(authToken));
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const saveIntelNotification = (authToken, payload,dt,wt) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "intent-notification/save",
        { notification_data: payload,
          daily_time:dt,
          weekly_time:wt,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          await dispatch({
            type: types.NOTIFICATION_DATA,
            payload: null,
          });
          dispatch(getNotificationData(authToken));

          Toast(response.data.message, "S");
          // dispatch(fetchNotificationCheckList(authToken));
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

// Calendly

export const cleanCalendlyUrl = () => {
  return (dispatch) => {
    dispatch({ type: types.FETCH_CALENDLY_URL, payload: "" });
  };
};

export const calendlyAuth = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("calendly-auth", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          // console.log(response.data,"calendly")
          dispatch({ type: types.FETCH_CALENDLY_URL, payload: response?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getCalendlyApiDetail = (authToken, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("get-calendly-user", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          onSuccess(response?.data?.data);
          dispatch({
            type: types.FETCH_CALENDLY_URL,
            payload: response?.data?.data?.auth_url,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const unlinkCalendlyApi = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("remove-account", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getCalendlyToken = (authToken, code, onSuccessToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(`get-token/${code}`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: types.CALENDLY_DATA, payload: response?.data });
          onSuccessToken();
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const hubspotAuth = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "hubspot-login",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          window.location.assign(response?.data?.redirect_url);
          // dispatch({ type: types.FETCH_CALENDLY_URL, payload: response?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getConnectHubspot = (authToken, code, onSuccessToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(`store-token`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.HUBSPOT_STATUS,
            payload: response.data?.connection_status,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getHubspotToken = (authToken, code) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        `store-token`,
        {
          code: code,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          if (response?.data?.message === "Connected Successfully") {
            window.location.assign("/Setting/hubspot");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
export const postSyncFields = (authToken, selectedItems) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        `sync-fields`,
        {
          hubspot_fields: selectedItems,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "S");
          await dispatch(getSyncFields(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getSyncFields = (authToken, code, onSuccessToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(`sync-fields`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: types.FIELDS_DATA, payload: null });
          dispatch({ type: types.FIELDS_DATA, payload: response?.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const submitHubspotMappingData = (authToken, newArr, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "map-fields",
        {
          details: newArr,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          await dispatch(fetchHubspotMappingData(authToken));
          Toast(response.data.message, "S");
          onSuccess();
          // setTimeout(()=>{
          //     window.location.assign("/Setting/hubspot")
          //   },3000)
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const fetchHubspotMappingData = (authToken, newArr) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("map-fields", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
          dispatch({
            type: types.HUBSPOT_MAPPED_DATA,
            payload: response?.data?.detail,
          });
          // setTimeout(()=>{
          //     window.location.assign("/Setting/hubspot")
          //   },3000)
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const fetchHubspotSyncListing = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("hubspot-permissions", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          let response_data = [];
          if (response?.data?.data?.length > 0) {
            response_data = response?.data?.data;
          } else {
            response_data = [
              {
                permissions: "1",
                permission_check: true,
                type: [
                  {
                    permission_type: "real",
                    check: true,
                  },
                  {
                    permission_type: "daily",
                    check: false,
                  },
                ],
              },
              {
                permissions: "2",
                permission_check: true,
                type: [
                  {
                    permission_type: "real",
                    check: false,
                  },
                  {
                    permission_type: "daily",
                    check: false,
                  },
                ],
              },
            ];
          }
          dispatch({ type: types.HUBSPOT_SYNC_DATA, payload: response_data });
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const submitHubspotSyncListingData = (authToken, payload, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        "hubspot-permissions",
        {
          hubspot_permissions: payload,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          onSuccess();
          Toast("Data sync successfully", "S");
          await dispatch(fetchHubspotSyncListing(authToken));
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const hubspotDeleteData = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("delete-sync-fields", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
          // console.log(response?.data,"data")
          dispatch({
            type: types.HUBSPOT_DELETE_DATA,
            payload: response?.data?.details,
          });
          // setTimeout(()=>{
          //     window.location.assign("/Setting/hubspot")
          //   },3000)
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const getStripeUpdate = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get(`stripe/get_payment_details`, {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "STRIPE_UPDATED_DATA", payload: response.data });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch Schedule
export const fetchScheduleListing = (authToken, flag) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: flag == "1" ? false : true });
    try {
      const response = await storeApis.post(
        "calender/get_schedule_details",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({
            type: types.FETCH_SCHEDULE_LIST,
            payload: response.data.response,
          });
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch Schedule
export const addScheduleListing = (authToken, payload) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/schedule_setting_data",
        payload,
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch(fetchScheduleListing(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Add User
export const createScheduleData = (
  authToken,
  s_name,
  default_data,
  s_time,
  s_id
) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/create_schedule",
        {
          schedule_id: s_id,
          schedule_name: s_name,
          timezone: s_time,
          default: default_data,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          if (response.data.response) {
            Toast(response.data.response, "E");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          await dispatch(fetchScheduleListing(authToken, default_data));
        } else {
          Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// schedule_override_data
export const addOverrideData = (
  authToken,
  data,
  date,
  slot,
  del_status,
  availability
) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/schedule_override_data",
        {
          schedule_id: data.schedule_id,
          date: date,
          override_slot_data: slot,
          availability: availability,
          deleted: del_status,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          if (response.data.response) {
            Toast(response.data.response, "E");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // await dispatch(fetchScheduleListing(authToken))
        } else {
          Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// deleteSchedule
export const deleteSchedule = (authToken, schedule_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/delete_schedule",
        {
          schedule_id: schedule_id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          if (response.data.response) {
            Toast(response.data.response, "E");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          await dispatch(fetchScheduleListing(authToken));
        } else {
          Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch Event
export const createEventData = (authToken, name, description, status, id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/create_event",
        {
          event_id: id,
          event_name: name,
          event_description: description,
          status: status,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch(fetchEventListing(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch Event Listing
export const fetchEventListing = (authToken, flag) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: flag == "1" ? false : true });
    try {
      const response = await storeApis.post(
        "calender/get_event_list",
        {},
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({
            type: types.FETCH_EVENT_LIST,
            payload: response.data?.data?.list,
          });
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch Event detail data
export const fetchEventDetail = (authToken, eventId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/get_event_data",
        {
          event_id: eventId,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({
            type: types.FETCH_EVENT_DETAIL,
            payload: response.data?.data,
          });
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// deleteEvent
export const deleteEventData = (authToken, event_id) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/delete_event",
        {
          event_id: event_id,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          if (response.data.response) {
            Toast(response.data.response, "E");
          } else {
            Toast(response.data.message, "E");
          }
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          await dispatch(fetchEventListing(authToken));
        } else {
          Toast(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch submit event setting

export const submitEventData = (
  authToken,
  onSuccess,
  allowedEvent,
  scheduleTimeLimit,
  scheduleTimeLimitInput,
  scheduleData,
  incrementTime,
  afterTime,
  beforeTime,
  durationData,
  date_range_structure,
  dateRangeCheck,
  id,
  setting_id
) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/event_setting_data",
        {
          event_setting_id: setting_id,
          event_id: id,
          schedule_id: scheduleData?.schedule_id,
          date_range_type: dateRangeCheck,
          meta_data: date_range_structure,
          duration: durationData,
          before_add_time: beforeTime,
          after_add_time: afterTime,
          start_time_increment: incrementTime,
          schedule_start: scheduleTimeLimitInput,
          schedule_start_type: scheduleTimeLimit?.value,
          max_event: 0,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          onSuccess();
          await dispatch(fetchEventListing(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const googleCalenderAuth = (authToken, onSuccessAuth) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("calender/google_connection", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({
            type: types.FETCH_GOOGLE_CALENDAR_URL,
            payload: response?.data?.redirect_uri,
          });
          onSuccessAuth(response?.data?.redirect_uri);
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getGoogleToken = (authToken, code) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.post(
        `calender/handleGoogleCallback`,
        {
          code: code,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const getGoogleCalenderApiDetail = (authToken, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("calender/list_location", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          onSuccess(response?.data?.data);
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
export const hubspotSyncData = (authToken, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("import-contacts", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({ type: "TOGGLE_LOADING", payload: false });
          onSuccess();
          // Toast(response.data.message, "S");
          // console.log(response?.data,"data")
          // dispatch({ type: types.HUBSPOT_DELETE_DATA, payload: response?.data?.details });
          // setTimeout(()=>{
          //     window.location.assign("/Setting/hubspot")
          //   },3000)
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const unlinkHubspotApi = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("disconnect-hubspot", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const unlinkCalenderApi = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: false });
    try {
      const response = await storeApis.get("calender/python_revoke_google", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "200") {
          Toast(response.data.message, "S");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
}

// Fetch Event Listing
export const fetchSyncPopupListing = (authToken) => {
  return async (dispatch) => {
      dispatch({ type: "TOGGLE_LOADING", payload: false});
      try {
          const response = await storeApis.get(
            "hubspot-lists",
            {
                headers: {
                    Accept: "application/json",
                    Authorization: `Bearer ${authToken}`,
                },
            }
          );
          if (response.status === 200) {
              if (response.data.statusCode == "403") {
                  dispatch({
                      type: "UNAUTHORIZED_SETTING",
                      payload: response.data.statusCode,
                  });
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
              }else if(response.data.statusCode == "400"){
                  console.log(response.data.message, "E");
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
              }
              else {
                  await dispatch({
                    type: types.FETCH_EVENT_POPUP_LIST,
                    payload: response.data?.data?.hubspot_list,
                  });
                  // await dispatch(fetchLeadsList(authToken));
                  dispatch({ type: "TOGGLE_LOADING", payload: false });
              }
          }
      } catch (err) {
          console.log(err.response.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
      }
  };
};

export const submitPopupSyncData = (authToken, listId, name, onSuccess) => {
    return async (dispatch) => {
        dispatch({ type: "TOGGLE_LOADING", payload: false });
        try {
            const response = await storeApis.post(
              `store-hubspot-lists`,
              {
                  list_id: [listId],
              },
              {
                  headers: {
                      Accept: "application/json",
                      Authorization: `Bearer ${authToken}`,
                  },
              }
            );
          if (response.status === 200) {
            if (response.data.statusCode == "403") {
                dispatch({
                    type: "UNAUTHORIZED_SETTING",
                    payload: response.data.statusCode,
                });
                dispatch({ type: "TOGGLE_LOADING", payload: false });
            } else if(response.data.statusCode == "400"){
                    console.log(response.data.message, "E");
                    dispatch({ type: "TOGGLE_LOADING", payload: false });
            } else {
                dispatch(fetchSyncPopupListing(authToken))
                onSuccess(name);
                dispatch({ type: "TOGGLE_LOADING", payload: false });
            }
          }
        } catch (err) {
            console.log(err.response.message, "E");
            dispatch({ type: "TOGGLE_LOADING", payload: false });
            dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
        }
    };
};
// fetch userData
export const fetchUserData = (authToken, eventId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("auth_user_details", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({
            type: types.FETCH_USER_DATA,
            payload: response.data?.data,
          });
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
export const SaveUserData = (authToken, fName,lName,mobile,companyName) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "update_user_details",
        {
          first_name: fName,
          last_name: lName,
          mobile: mobile,
          company_name: companyName,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "S");
          dispatch(fetchUserData(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

// Fetch Select Calendar Data

export const fetchSelectedCalendar = (authToken, eventId) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("calender/get_calender_type", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          await dispatch({
            type: types.FETCH_SELECTED_CALENDAR,
            payload: response.data?.data,
          });
          // console.log(response.data?.data)
          // await dispatch(fetchLeadsList(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};

export const submitSelectedCalendar = (authToken, data) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "calender/change_calender_type",
        {
          default: data,
        },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else if (response.data.statusCode == "400") {
          console.log(response.data.message, "E");
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          Toast(response.data.message, "S");
          dispatch(fetchSelectedCalendar(authToken));
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        }
      }
    } catch (err) {
      console.log(err.response.message, "E");
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({ type: "UNAUTHORIZED_SETTING", payload: err.response.status });
    }
  };
};
// Zoi Visiblity
//Get token
export const getVisiblity = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("chatbot_permission", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.ZOI_VISIBILITY,
            payload: response.data,
          });
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const getIntelSetting = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("/intent/get_intent_settings", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.INTEL_SETTING,
            payload: response.data,
          });
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const postVisiblity = (authToken,value) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post("chatbot_permission",
      {
        client_id:"",
        action:"chatBot",
        show_chatbot:value,
        method_type:"admin"
      },
       {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(getVisiblity(authToken));
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const getPlanDetails = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("payment-gateway/plans", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.PLAN_DETAILS,
            payload: response.data,
          });
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const createRazorpayOrder = (authToken,planID,customerDetails) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "payment-gateway/create-order",
        {
         plan_id:planID,
         payment_mode:"online",
         customer_details:customerDetails 
      },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          // console.log(response?.data,"dat hai ")
          window.location.assign(response?.data?.order_details?.subscriptionData?.short_url);
          // await dispatch({ type: types.FETCH_BILLING_URL, payload: null });
          // dispatch({
          //   type: types.FETCH_BILLING_URL,
          //   payload: response?.data?.session_url,
          // });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
export const intentSetting = (authToken,se,ll,sb,hr) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post("intent/intent_settings",
      {
        search_engine: "Bing News Search API", //GNews,Bing
        llm: ll, //openai,claude
        sort_by: sb ,//date,relevance
        human_prompt: hr

      },
       {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(getIntelSetting(authToken));
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const paymentDetails = (authToken,rPid,rOid,base) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "payment-gateway/payment",
        {
          razorpay_payment_id:rPid,
          razorpay_order_id: rOid
      },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch(getIntelSetting(authToken));
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};

export const paymentHistory = (authToken,rPid,rOid,base) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.post(
        "payment-gateway/order_history",
        {
          limit:"100",
          page: "1"
      },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
        } else {
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          dispatch({ type: "PAYMENT_HISTORY", payload: response?.data });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};


export const getNotificationData = (authToken) => {
  return async (dispatch) => {
    dispatch({ type: "TOGGLE_LOADING", payload: true });
    try {
      const response = await storeApis.get("intent-notification/list", {
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
      if (response.status === 200) {
        if (response.data.statusCode == "403") {
          dispatch({
            type: "UNAUTHORIZED_SETTING",
            payload: response.data.statusCode,
          });
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "E");
        } else {
          dispatch({
            type: types.NOTIFICATION_DATA,
            payload: response.data,
          });
          //   console.log(response.data,"imp")
          dispatch({ type: "TOGGLE_LOADING", payload: false });
          // Toast(response.data.message, "S");
        }
      }
    } catch (err) {
      console.log("ERROR", err);
      dispatch({ type: "TOGGLE_LOADING", payload: false });
      dispatch({
        type: "UNAUTHORIZED_SETTING",
        payload: err.response.status,
      });
    }
  };
};
